import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import idb from 'localforage';

Vue.use(VueRouter);

const routes = [
    {
        path: '/list/:prdcd',
        name: 'List',
        component: () => import('../views/List.vue'),
        beforeEnter: async (to, from, next) => {
            if (undefined == to) {
                if ('Y' == store.state.appYn) {
                    location.href = 'toapp://close';
                } else {
                    window.close();
                }
            }
            store.commit('SET_TITLE', '포토리뷰');
            if (from.path.startsWith('/thumblist/')) {
                await idb.setItem('checkFromThumbList', 'Y');
            } else {
                await idb.setItem('checkFromThumbList', 'N');
            }
            let prdcd = await idb.getItem('prdcd');
            if (
                Number.isNaN(Number(to.params.prdcd)) &&
                Number.isNaN(Number(prdcd))
            ) {
                alert('정상적인 경로로 접근해 주세요');
                next(from);
                return;
            }
            if (store.state.lastMessageId == 0) {
                if (Number(to.params.prdcd) > 0) {
                    prdcd = to.params.prdcd;
                    await idb.setItem('prdcd', to.params.prdcd);
                }
                //await store.dispatch('GET_OPTIONS', prdcd);
                await store.dispatch('FETCH_ITEMS', prdcd);
            }
            next();
        },
    },
    {
        path: '/thumblist/:prdcd/:index',
        name: 'ThumbList',
        component: () => import('../views/ThumbList.vue'),
        beforeEnter: async (to, from, next) => {
            if (undefined == to) {
                if ('Y' == store.state.appYn) {
                    location.href = 'toapp://close';
                } else {
                    window.close();
                }
            }
            store.commit('SET_TITLE', '포토리뷰');
            let prdcd = await idb.getItem('prdcd');
            if (Number.isNaN(Number(to.params.index))) {
                alert('정상적인 경로로 접근해 주세요');
                next(from);
                return;
            }
            if (store.state.lastMessageId == 0) {
                if (Number(to.params.prdcd) > 0) {
                    prdcd = to.params.prdcd;
                    await idb.setItem('prdcd', to.params.prdcd);
                }
                await store.dispatch('GET_OPTIONS', prdcd);
                await store.dispatch('FETCH_ITEMS', prdcd);
            }
            // if(store.state.lastMessageId == 0 && !Number.isNaN(Number(prdcd))) {
            //   next("/list/"+prdcd);
            //   return;
            // }
            next();
        },
    },
    {
        path: '/detail/:prdcd/:messageId',
        name: 'Detail',
        component: () => import('../views/Detail.vue'),
        beforeEnter: async (to, from, next) => {
            if (undefined == to) {
                if ('Y' == store.state.appYn) {
                    location.href = 'toapp://close';
                } else {
                    window.close();
                }
            }
            store.commit('SET_TITLE', '고객 리뷰');
            if (Number.isNaN(Number(to.params.messageId))) {
                alert('정상적인 경로로 접근해 주세요');
                next(from);
                return;
            }
            // if(store.state.lastMessageId == 0) {
            await store.dispatch('GET_ITEM', {
                prdcd: to.params.prdcd,
                messageId: to.params.messageId,
            });
            // }
            next();
        },
    },
    {
        path: '/report/:prdcd/:messageId',
        name: 'Report',
        component: () => import('../views/Report.vue'),
        beforeEnter: async (to, from, next) => {
            if (undefined == to) {
                if ('Y' == store.state.appYn) {
                    location.href = 'toapp://close';
                } else {
                    window.close();
                }
            }
            store.commit('SET_TITLE', '불량글 신고하기');
            await store.dispatch('GET_REPORT_OPTION');
            next();
        },
    },
];

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
            };
        } else {
            if (savedPosition) {
                return savedPosition;
            } else {
                return { x: 0, y: 0 };
            }
        }
    },
});

export default router;
